// Config
import localeConfig from '../config/locale-config'
import packConfig, { LocalePackConfig } from '../config/pack-config'

function getPackConfigByLocale(locale: string): LocalePackConfig {
    if (!locale) throw new Error('locale is mandatory in getPackConfigByLocale')
    if (!localeConfig.has(locale)) throw new Error('invalid locale, does not exist in localeConfig in getPackConfigByLocale')

    return packConfig[locale]
}

export default getPackConfigByLocale
